import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './BrandOnboardingRecompletedPanel.scss';

import { updateBrand } from '../../../Actions/BrandActions';
import { syncCurrentUser } from '../../../Actions/UserActions';
import { clearOnboardingObjects } from '../../../Actions/OnboardingActions';

import { getBrand } from '../../../Helpers/user_helpers';
import { brandOnboardingStatuses } from '../../../Helpers/onboarding_helpers';

import BrandOnboardingProgressBar from '../BrandOnboardingProgressBar';

const BrandOnboardingRecompletedPanel = props => {
  const { user } = props;
  const history = useHistory();

  const onNextClick = async () => {
    if (props.isLoading) return;

    props.setIsLoading(true);
    const response = await props.updateBrand(getBrand(user), { onboardingStatus: brandOnboardingStatuses.COMPLETE });
    if (!response.success) return window.ALERT.error('An error occurred while updating your account. Please try again.');
    await props.syncCurrentUser();
    await props.clearOnboardingObjects();
    props.setIsLoading(false);

    history.push('/links');
  };

  return (
    <div className='brand-onboarding-recompleted-panel-outer'>
      <div className='brand-onboarding-recompleted-panel-inner'>
        <div className='brand-onboarding-split-container-outer'>
          <div className='brand-onboarding-split-container-inner'>
            <div className='brand-onboarding-graphic-container-outer'>
              <div className='brand-onboarding-graphic-container-inner'>
                <div className='brand-onboarding-graphic-container-stat'>
                  <div className='brand-onboarding-graphic-container-stat-label'>Our Numbers</div>
                  <div className='brand-onboarding-graphic-container-stat-number'>{props.featuredStat.number}+</div>
                  <div className='brand-onboarding-graphic-container-stat-description'>{props.featuredStat.description}</div>
                </div>

                <BrandOnboardingProgressBar
                  goToPanel={props.goToPanel}
                  sections={props.sections}
                  activeSectionName={props.activeSectionName}
                  activePanelName={props.activePanelName}
                />
              </div>

              <div className='brand-onboarding-graphic-background'>
                <img className='brand-onboarding-graphic-background-image' src={props.backgroundImage} alt='name panel graphic' />
                <div className='brand-onboarding-graphic-background-overlay'></div>
              </div>
            </div>

            <div className='brand-onboarding-input-container-outer'>
              <div className='brand-onboarding-input-container-number-marker'>{props.panelNumber}</div>

              <div className={cn('brand-onboarding-input-container-inner', { isLoading: props.isLoading })}>
                <div className='brand-onboarding-title-text'>Welcome back to ShopMy!</div>
                <div className='brand-onboarding-subtitle-text'>
                  We had some updates for you to fill out but your account is fully setup again. Continue from here to access your dashboard.
                </div>

                <div className='brand-onboarding-pagination-buttons'>
                  <button className='brand-onboarding-button stretch' onClick={() => props.goToPreviousPanel()}>
                    Back
                  </button>
                  <button className='brand-onboarding-button stretch primary' onClick={onNextClick}>
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

BrandOnboardingRecompletedPanel.propTypes = {
  onboarding: PropTypes.object.isRequired,
  updateBrand: PropTypes.func.isRequired,
  syncCurrentUser: PropTypes.func.isRequired,

  panels: PropTypes.array.isRequired,
  goToPreviousPanel: PropTypes.func.isRequired,
  goToNextPanel: PropTypes.func.isRequired,
  goToPanel: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const { onboarding, user } = state;
  return { onboarding, user };
};

export default connect(mapStateToProps, {
  updateBrand,
  syncCurrentUser,
  clearOnboardingObjects
})(withRouter(BrandOnboardingRecompletedPanel));
